import { FC, RefObject, useCallback, useEffect, useRef, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import css from 'classnames'
import { useTranslation } from 'react-i18next'
import { Props } from './types'
import { SVGDownLoad } from '../SVG/SVGDownLoad'
import { Spinner } from '../spinner'

export const DropFileZone: FC<Props> = ({
  accept,
  onChange,
  className,
  children,
  dropFileZoneRefIcon,
  dropZoneRefBanner,
  dropFileZoneRefLogo,
  warning,
  error,
  isLoading,
  text,
}) => {
  const { t } = useTranslation()
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      onChange?.(acceptedFiles)
    },
    [onChange],
  )
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 })
  const containerRef = useRef(null)

  const { isDragActive, getRootProps, getInputProps, inputRef } = useDropzone({
    accept,
    onDrop,
  })
  const assignRef = (
    ref: RefObject<HTMLInputElement | null> | undefined,
    node: HTMLInputElement | null,
  ) => {
    if (ref) {
      const mutableRef = ref as { current: HTMLInputElement | null }
      mutableRef.current = node
    }
  }

  const setInputRef = (node: HTMLInputElement | null) => {
    assignRef(dropFileZoneRefLogo, node)
    assignRef(dropFileZoneRefIcon, node)
    assignRef(dropZoneRefBanner, node)
    const mutableDropzoneRef = inputRef as { current: HTMLInputElement | null }
    mutableDropzoneRef.current = node
  }

  useEffect(() => {
    // Обновление размера контейнера при изменении размера окна или других факторов
    const updateContainerSize = () => {
      if (containerRef.current) {
        const { offsetWidth, offsetHeight } = containerRef.current
        setContainerSize({ width: offsetWidth, height: offsetHeight })
      }
    }

    window.addEventListener('resize', updateContainerSize)
    updateContainerSize() // Инициализация размера при монтировании

    return () => {
      window.removeEventListener('resize', updateContainerSize)
    }
  }, [])
  const iconSize = containerSize.width <= 200 ? 32 : 40
  const textSize = containerSize.width <= 200 ? 'text-xs' : 'text-sm'
  const textStyles = `font-light ${textSize} text-center`

  return isLoading ? (
    <div className="w-full h-full flex items-center justify-center">
      <Spinner />
    </div>
  ) : (
    <div
      ref={containerRef}
      {...getRootProps()}
      className={css(
        className,
        'w-full dashed p-4 rounded flex flex-col gap-3 items-center justify-center transition-all',
        { 'bg-gray-100 bg-none': isDragActive },
        { dashedWarning: warning }, // from index.css
        { dashedError: error },
      )}
      style={{ whiteSpace: 'normal' }}
    >
      {children}
      <input {...getInputProps()} ref={setInputRef} />

      <SVGDownLoad size={String(iconSize)} />

      <p className={` ${textStyles}`}>{text || t('dndPic')}</p>
    </div>
  )
}
